import { gql } from '@apollo/client';

export const GET_USER_BALANCE = gql`
  query GetUserBalance($urlSlug: String) {
    getUserBalance(urlSlug: $urlSlug) {
      userId
      balance
      updatedAt
      collabPartnerName
    }
  }
`;
